import { connect } from "react-redux";
import VendorList from "./vendorList";
import { bindActionCreators } from "redux";
import { getVendorOnboardingList, getVendorOnboardedListSearch, vendorEditRequest } from "services/redux/sales/vendorPortal/action";

const mapStateToProps = (state) => ({
  postSalesList: state.vendorPortalReducer.vendorOnboardedList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getVendorOnboardingList,
      getVendorOnboardedListSearch,
      vendorEditRequest,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(VendorList);
